"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTwitterUrl = void 0;
var utils_1 = require("../utils");
var objectToUrlParams_1 = __importDefault(require("./objectToUrlParams"));
var getTwitterUrl = function (_a) {
    var url = _a.url, text = _a.text, hashtags = _a.hashtags, related = _a.related;
    return "https://twitter.com/share" + objectToUrlParams_1.default({
        url: url,
        text: text,
        hashtags: utils_1.commaSeparate(hashtags),
        related: utils_1.commaSeparate(related),
    });
};
exports.getTwitterUrl = getTwitterUrl;
exports.default = exports.getTwitterUrl;
//# sourceMappingURL=getTwitterUrl.js.map